<app-legal-document documentType="terms" mode="page"></app-legal-document>
